export const SELLER_DASHBOARD_ONLINE_DATE = '2025/10/01'
